import { Array } from 'stdlib/Array'

import type { TBrowser } from '../definitions'
import { IE_BROWSERS } from '../definitions'

/**
 * IE-t használ a user.
 * @param browser - Browser típusa.
 */
export default function isIE (browser: TBrowser): boolean { // eslint-disable-line @typescript-eslint/naming-convention
  return Array.includes(IE_BROWSERS, browser)
}
